import React from 'react';

import { Button } from 'components/ui';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';

export default function StartChat({ onStartChat }) {
  return (
    <div className="w-fill h-300 d-f fd-c jc-c ai-c bg-white ta-c pl-16 pr-16">
      <Button customColor onClick={onStartChat}>
        {t('practice.on_demand_practice.conversation.start_chat')}
      </Button>
      <Text className="mt-16" variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD}>
        {t('practice.on_demand_practice.conversation.start_chat_instructions')}
      </Text>
    </div>
  );
}
